import React from 'react';
import { useNavigate } from 'react-router-dom';
import { logout } from '../services/api';
import { BRAND_NAME } from '../branding';
import PasskeyEnrol from '../components/PasskeyEnrol';
import { showSuccess } from '../components/ToastNotifications';
import './Login.css';

// Compulsory passkey setup for administrators (operator rule 2026-10-24):
// App.js renders ONLY this page while the signed-in admin's
// passkeySetupRequired flag is set — the server also refuses every other API
// call (403 PASSKEY_SETUP_REQUIRED) until a passkey is registered.
function PasskeySetupRequired({ user, setUser }) {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try { await logout(); } catch (err) { /* best-effort */ }
    setUser(null);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-brand">{BRAND_NAME}</div>
        <h1 className="login-title">Set up a passkey</h1>
        <p className="login-subtitle">
          Administrator accounts must have a passkey. From now on, adding, changing or removing a user needs it, and you can sign in with it instead of a code. This takes a few seconds and is required before you can continue.
        </p>

        <PasskeyEnrol
          onDone={(r) => {
            showSuccess('Passkey set up');
            setUser({ ...user, passkeyEnabled: true, passkeySetupRequired: false, passkeyCount: r?.passkeyCount || 1 });
            navigate('/dashboard');
          }}
        />

        <div style={{ textAlign: 'center', marginTop: 'var(--spacing-lg, 16px)' }}>
          <button type="button" className="btn btn-outline btn-small" onClick={handleSignOut}>
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}

export default PasskeySetupRequired;
